import { styled } from 'styled-components'

export const HorizontalLine = styled.span`
    height: 50%;
    width: 100%;
    flex: 1;
    border-bottom: ${props => `solid 1px ${props.theme.colorBorder}`};
`
